const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Compact relative timestamp for feed cards: "Just now", "5m ago", "3h ago",
 * "2d ago". Anything 30+ days old falls back to a short date ("Mar 4, 2026")
 * since "400d ago" isn't useful. Future dates (clock skew) read as "Just now".
 * @param {Date | string | null | undefined} date
 * @param {Date} now - Injected for testability.
 * @returns {string} Empty string when the date is missing or invalid.
 */
export function timeAgo(date: Date | string | null | undefined, now: Date = new Date()): string {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  const time = d.getTime();
  if (Number.isNaN(time)) return '';

  const diff = now.getTime() - time;
  if (diff < MINUTE) return 'Just now';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h ago`;

  const days = Math.floor(diff / DAY);
  if (days < 30) return `${days}d ago`;

  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
